exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AddActivityModal-module__wrapper___qa8Yg{padding:.5rem}.AddActivityModal-module__wrapper___qa8Yg .AddActivityModal-module__top___WDVMX{display:grid;grid-template-columns:1fr auto;margin-bottom:1.25rem}@media screen and (max-width:510px){.AddActivityModal-module__wrapper___qa8Yg .AddActivityModal-module__top___WDVMX{grid-template-columns:auto;gap:.5rem;justify-items:center;grid-auto-flow:row}}", ""]);

// exports
exports.locals = {
	"wrapper": "AddActivityModal-module__wrapper___qa8Yg",
	"top": "AddActivityModal-module__top___WDVMX"
};